import { useState } from "react";
import "./AdminCriarParceiros.css";

function AdminCriarParceiro({
  localizacao,
  setMarcas,
  onClose,
}) {
  const [nome, setNome] = useState("");

  const [arquivo, setArquivo] =
    useState(null);

  const [preview, setPreview] =
    useState(null);

  const [salvando, setSalvando] =
    useState(false);

  const handleSelecionarImagem = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setArquivo(file);

    const reader = new FileReader();

    reader.onload = (event) => {
      setPreview(event.target.result);
    };

    reader.readAsDataURL(file);
  };

  const handleSalvar = async () => {
    if (!nome.trim()) {
      alert("Informe o nome.");
      return;
    }

    if (!arquivo) {
      alert("Selecione uma imagem.");
      return;
    }

    try {
      setSalvando(true);

      const formData = new FormData();

      formData.append(
        "imagem",
        arquivo
      );

      const uploadResponse =
        await fetch(
          "https://app.eliandroalimentos.com.br/api/imagem/upload",
          {
            method: "POST",
            body: formData
          }
        );

      const uploadData =
        await uploadResponse.json();

      if (!uploadResponse.ok) {
        throw new Error(
          "Erro ao enviar imagem"
        );
      }

      const imagem =
        uploadData.caminho;

      const response =
        await fetch(
          "https://app.eliandroalimentos.com.br/api/marcas/criar",
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json"
            },
            body: JSON.stringify({
              nome,
              imagem,
              localizacao
            })
          }
        );

      const data =
        await response.json();

      if (!response.ok) {
        throw new Error(
          data.message ||
            "Erro ao criar parceiro"
        );
      }

      const novoParceiro = {
        id:
          data.id ||
          Date.now(),
        nome,
        imagem,
        localizacao
      };

      setMarcas(prev => [
        ...prev,
        novoParceiro
      ]);

      onClose();

    } catch (error) {
      alert(error.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div
      className="admin-parceiro-editar-overlay"
      onClick={onClose}
    >
      <div
        className="admin-parceiro-editar"
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="admin-parceiro-header">
          <h2>
            Novo Parceiro
          </h2>

          <button
            className="fechar"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="admin-parceiro-conteudo">

          <div className="campo">
            <label>Nome</label>

            <input
              value={nome}
              onChange={(e) =>
                setNome(
                  e.target.value
                )
              }
            />
          </div>

          <div className="bloco-preview">
            <h3>
              Nova Imagem (1772 × 10866 px) .jpg
            </h3>

            <input
              type="file"
              accept="image/*"
              onChange={
                handleSelecionarImagem
              }
            />

            {preview && (
              <div className="preview-original-AdminCriarParceiro">
                <img
                  src={preview}
                  alt=""
                />
              </div>
            )}
          </div>

          {preview && (
            <div className="bloco-preview">
              <h3>
                Como ficará no site
              </h3>

              <div className="preview-parceiro-adminCriarParceiro">
                <img
                  src={preview}
                  alt=""
                />
              </div>
            </div>
          )}
        </div>

        <div className="admin-parceiro-footer">
          <button
            className="btn-cancelar"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            className="btn-salvar"
            onClick={handleSalvar}
            disabled={salvando}
          >
            {salvando
              ? "Salvando..."
              : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminCriarParceiro;